import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { fadeInRightAnimation } from 'src/@fury/animations/fade-in-right.animation';
import { fadeInUpAnimation } from 'src/@fury/animations/fade-in-up.animation';
import { scaleInAnimation } from 'src/@fury/animations/scale-in.animation';
import { ApiService } from 'src/app/services/api.service';
import { Location } from '@angular/common';
import { ErrorType } from 'src/app/enums/error-type.enum';
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import * as moment from 'moment';

@Component({
  selector: 'fury-edit-service-agreement-version',
  templateUrl: './edit-service-agreement-version.component.html',
  styleUrls: ['./edit-service-agreement-version.component.scss'],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation],
})
export class EditServiceAgreementVersionComponent implements OnInit, OnDestroy {

  agreementVersionForm!: FormGroup;
  agreementVersionDetails: any;
  ngUnsubscribe = new Subject<void>();
  constructor(
    public apiService: ApiService,
    public location: Location
  ) { }

  ngOnInit(): void {
   this.formInIt();
   this.getServiceAgrementVersionDetails();
  }
  getServiceAgrementVersionDetails() {
    this.apiService
      .get(
        "admin/settings/service-agreement-version/get-service-agreement-version-settings"
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (res: HttpResponse<any>) => {
          if (res.body) {
            this.agreementVersionDetails = res.body.serviceAgreementPdfVersionSetting;
            this.agreementVersionForm.patchValue(this.agreementVersionDetails);
          }
        },
        (err: HttpErrorResponse) => {
          this.apiService.alert(err.message, ErrorType.Error);
        }
      );
  }
  formInIt() {
    this.agreementVersionForm = new FormGroup({
      serviceAgreementVersion: new FormControl('', [Validators.required]),
      versionUpdated: new FormControl('', [Validators.required]),
    });
  }
  update(){
   if(this.agreementVersionForm.valid){
    let data : any = {
      serviceAgreementVersion: this.agreementVersionForm.value.serviceAgreementVersion,
      versionUpdated: moment(this.agreementVersionForm.value.versionUpdated).format('YYYY-MM-DD')
    }
    this.apiService.post('admin/settings/service-agreement-version/save-service-agreement-version-settings', data).pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: HttpResponse<any>)=>{
      if(res){
        this.location.back();
        this.apiService.alert(res.body.message, ErrorType.Success);
      }
    }, (err: HttpErrorResponse)=>{
      this.apiService.alert(err.message, ErrorType.Error);
    })
   } else {
    this.agreementVersionForm.markAllAsTouched();
   }
  }
  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
